import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4be5ea2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "tabs"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "rgb(0, 129, 255)",
    d: "M17.65 6.35A7.958 7.958 0 0 0 12 4a8 8 0 0 0-8 8a8 8 0 0 0 8 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18a6 6 0 0 1-6-6a6 6 0 0 1 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
  })
], -1))
const _hoisted_4 = { class: "form" }
const _hoisted_5 = {
  key: 0,
  class: "content-wrapper"
}
const _hoisted_6 = {
  key: 0,
  class: "content"
}
const _hoisted_7 = {
  class: "sign-key-form",
  id: "sign-key-form"
}
const _hoisted_8 = { class: "fields" }
const _hoisted_9 = { for: "CAList" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("select", {
  name: "CAList",
  id: "CAList"
}, null, -1))
const _hoisted_11 = { class: "fields" }
const _hoisted_12 = { for: "sign-file" }
const _hoisted_13 = { class: "file-input-wrapper" }
const _hoisted_14 = {
  type: "file",
  id: "sign-file",
  accept: ".jks, .pfx, .pk8, .zs2, .dat",
  required: "",
  ref: "signFileInput"
}
const _hoisted_15 = { class: "fields" }
const _hoisted_16 = { for: "sign-password" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-key hide" }, null, -1))
const _hoisted_19 = {
  id: "file-sign-form",
  class: "hide"
}
const _hoisted_20 = {
  key: 0,
  class: "fields"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "content-wrapper"
}
const _hoisted_23 = {
  key: 0,
  class: "content"
}
const _hoisted_24 = {
  class: "sign-key-form",
  id: "sign-token-form"
}
const _hoisted_25 = { class: "fields" }
const _hoisted_26 = { for: "kmDevices" }
const _hoisted_27 = { class: "fields" }
const _hoisted_28 = { for: "sign-password" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { class: "fields" }
const _hoisted_31 = { for: "ca_list" }
const _hoisted_32 = { class: "fields" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-key hide" }, null, -1))
const _hoisted_34 = {
  key: 2,
  class: "file-list-modal"
}
const _hoisted_35 = { class: "file-list-modal--wrapper" }
const _hoisted_36 = { class: "file-list" }
const _hoisted_37 = {
  key: 0,
  class: "status-signed"
}
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 2,
  class: "status-nosigned"
}
const _hoisted_40 = {
  key: 0,
  class: "video file-list"
}
const _hoisted_41 = {
  key: 0,
  class: "photo-preview"
}
const _hoisted_42 = {
  class: "video-preview",
  controls: ""
}
const _hoisted_43 = ["src"]
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_45 = {
  key: 0,
  class: "status-signed"
}
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 2,
  class: "status-nosigned"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            style: {"border-radius":"4px 0 0 0"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.switchSignMethod('file');}),
            class: _normalizeClass({ 'active-tab': _ctx.activeTab === 'file' })
          }, _toDisplayString(_ctx.$t("files.byFile")), 3),
          _createVNode(_component_Popper, {
            placement: 'top',
            locked: true,
            content: _ctx.$t('files.tokenRefresh'),
            hover: _ctx.activeTab === 'token'
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                style: {"border-radius":"0 4px 0 0"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchSignMethod('token'))),
                class: _normalizeClass([{ 'active-tab': _ctx.activeTab === 'token' }, "token-btn"])
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("files.byToken")), 1),
                _hoisted_3
              ], 2)
            ]),
            _: 1
          }, 8, ["content", "hover"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.activeTab === 'file')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.loaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("form", {
                      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSignKeySubmit && _ctx.onSignKeySubmit(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("files.ca")), 1),
                        _hoisted_10
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("files.key")) + " (" + _toDisplayString(_ctx.$t("files.keyTypes")) + ") ", 1),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("input", _hoisted_14, null, 512)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("files.labelPwd")), 1),
                        _createElementVNode("input", {
                          type: "password",
                          id: "sign-password",
                          required: "",
                          ref: "password",
                          placeholder: _ctx.$t('files.keyPwd')
                        }, null, 8, _hoisted_17)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fields", { actions_btns: _ctx.isAdmin }])
                      }, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSignReadClick && _ctx.onSignReadClick(...args))),
                          id: "sign-read"
                        }, _toDisplayString(_ctx.$t("files.keyRead")), 1),
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "fields__close-btn",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('hideSign')))
                            }, _toDisplayString(_ctx.$t("files.btn_close")), 1))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 32),
                    _hoisted_18
                  ]),
                  _createElementVNode("form", _hoisted_19, [
                    (!_ctx.allFileSigned)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (_ctx.isAdmin)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t("files.sign_title_for_admin")), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFileSignClick && _ctx.onFileSignClick(...args)))
                          }, _toDisplayString(_ctx.$t("files.sign")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 'token')
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_ctx.loaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("form", {
                      onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSignKeySubmit && _ctx.onSignKeySubmit(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("files.kmDevices")), 1),
                        _withDirectives(_createElementVNode("select", {
                          name: "kmDevices",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.kmDevices) = $event)),
                          id: "kmDevices"
                        }, null, 512), [
                          [_vModelSelect, _ctx.kmDevices]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("files.labelPwd")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.kmPassword) = $event)),
                          id: "kmPassword",
                          required: "",
                          ref: "kmPassword",
                          placeholder: _ctx.$t('files.keyPwd')
                        }, null, 8, _hoisted_29), [
                          [_vModelText, _ctx.kmPassword]
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_30, [
                        _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("files.ca")), 1),
                        _withDirectives(_createElementVNode("select", {
                          name: "ca_list",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.caIndex) = $event)),
                          id: "ca_list"
                        }, null, 512), [
                          [_vModelSelect, _ctx.caIndex]
                        ])
                      ], 512), [
                        [_vShow, _ctx.euSignWrapper.privatKeyReaded]
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        (!_ctx.euSignWrapper.privatKeyReaded)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onTokenReadClick && _ctx.onTokenReadClick(...args))),
                              id: "startSign"
                            }, _toDisplayString(_ctx.$t("files.keyRead")), 1))
                          : _createCommentVNode("", true),
                        (_ctx.euSignWrapper.privatKeyReaded)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onFileSignClick && _ctx.onFileSignClick(...args))),
                              id: "startSign"
                            }, _toDisplayString(_ctx.$t("files.startSign")), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 32),
                    _hoisted_33
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.fileListModalVisible && !_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photo, (file, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "file-item"
                  }, [
                    _createElementVNode("span", null, [
                      (!_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "photo-preview",
                            style: _normalizeStyle({'background-image' : `url('${file.base64}')`})
                          }, null, 4))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(file.name), 1)
                    ]),
                    (file.signed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t("files.signed")), 1))
                      : (file.inProgress)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t("files.inProgress")), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t("files.nSigned")), 1))
                  ]))
                }), 128))
              ]),
              (_ctx.video.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.video, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "file-item"
                      }, [
                        _createElementVNode("span", null, [
                          (!_ctx.isAdmin)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createElementVNode("video", _hoisted_42, [
                                  _createElementVNode("source", {
                                    src: file.base64,
                                    type: "video/webm"
                                  }, null, 8, _hoisted_43),
                                  _hoisted_44
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(file.name), 1)
                        ]),
                        (file.signed)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.$t("files.signed")), 1))
                          : (file.inProgress)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.$t("files.inProgress")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.$t("files.nSigned")), 1))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}